var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('XTable',_vm._b({ref:"table",attrs:{"columns":_vm.columnsFilter,"data-api":_vm.dataApi,"params":_vm.params,"paging":false},scopedSlots:_vm._u([{key:"operation",fn:function(ref){
var cellData = ref.cellData;
var record = ref.record;
return [_vm._t("default",null,{"cellData":cellData,"record":record})]}}],null,true)},'XTable',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }